/*
 * Copyright (c) 2026. Tooling Team
 */

import PropTypes from "prop-types";
import { useContext } from "react";
import { Link } from "react-router-dom";
import { PATHS } from "../../../../../utils/constants";
import { LabCodeEvidenceNavigationContext } from "../../utils/contexts";
import { formatCellValue } from "../../utils/formatters";

const getCodeEvidencePath = (row) => {
  const mapUuid = row?.mapUuid;
  const localSystem = row?.localCodeSystem;
  const localCode = row?.localCode;

  if (!mapUuid || !localSystem || !localCode) return null;

  const searchParams = new URLSearchParams({ mapUuid, localSystem, localCode });

  return {
    pathname: PATHS.labDomainCodeEvidence.url,
    search: `?${searchParams.toString()}`,
    state: { mapUuid, localSystem, localCode },
  };
};

const LocalCodeCell = (cell) => {
  const navigation = useContext(LabCodeEvidenceNavigationContext);
  const row = cell.row?.original;
  const value = cell.getValue?.();
  const codeEvidencePath = getCodeEvidencePath(row);

  if (!codeEvidencePath) return formatCellValue(value);

  const returnState = navigation?.getReturnState?.();
  const linkTarget = {
    ...codeEvidencePath,
    state: {
      ...codeEvidencePath.state,
      labMvdReturnState: returnState,
    },
  };

  return (
    <Link
      to={linkTarget}
      onClick={(event) => {
        const shouldContinue =
          navigation?.handleCodeEvidenceNavigation?.(linkTarget) ?? true;

        if (!shouldContinue) {
          event.preventDefault();
        }
      }}
    >
      {formatCellValue(value)}
    </Link>
  );
};

LocalCodeCell.propTypes = {
  getValue: PropTypes.func,
  row: PropTypes.object,
  table: PropTypes.object,
};

export default LocalCodeCell;
